/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum NumberFilterOptionEnum {
    ALL = 'all',
    CHOOSE = 'choose'
}
